import { html, LitElement } from 'lit-element';
import { latexToHTML } from '../headerBlocks/utils.js';

/**
 * @element question-modal-math-inline
 * @prop {Object} model - Response
 * @prop {String} markup - Response
 */
export class QuestionModalMathInline extends LitElement {
  static get properties() {
    return {
      model: {
        type: Object,
        attribute: false,
      },
      markup: {
        type: String,
        attribute: false,
      },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { prompt, expression } = this.model || {};

    if (!expression) return '';

    const textValue = expression.replace(/\{\{[^}]*\}\}/g, () => {
      return '\\fbox{Response area}';
    });

    if (prompt) {
      return html` <div>
        <div class="question-modal modal-response-content">
          <math-rendering-element
            .label="${latexToHTML(textValue)}"
          ></math-rendering-element>
        </div>
      </div>`;
    }

    const markupSlot = html`<span
      className="modal-response-content"
      slot="${this.model.element.toLowerCase()}-${this.model.id}"
    >
      <math-rendering-element
        .label="${latexToHTML(textValue)}"
      ></math-rendering-element>
    </span>`;

    return html` <div class="question-modal">
      <markup-wrapper .markup="${this.markup}" .markupSlots="${markupSlot}">
      </markup-wrapper>
    </div>`;
  }
}

export default QuestionModalMathInline;
